/* Presentation only: expose the full chosen ignition name on narrow cards.
   Native selects retain their options, value, listeners and accessible name. */
(function () {
  'use strict';
  function init() {
    var root = document.getElementById('efCfg');
    if (!root || root.hasAttribute('data-ef-lab-extra-labels')) return;
    root.setAttribute('data-ef-lab-extra-labels', '');
    var queued = false;
    function sync() {
      queued = false;
      root.querySelectorAll('[data-efx-uac] select[aria-label="Ignition"]').forEach(function (select) {
        var caption = select.nextElementSibling;
        if (!caption || !caption.classList.contains('ef-lab-selected-option')) {
          caption = document.createElement('span');
          caption.className = 'ef-lab-selected-option';
          caption.setAttribute('aria-hidden', 'true');
          select.insertAdjacentElement('afterend', caption);
        }
        var option = select.options[select.selectedIndex];
        var text = option ? option.textContent.trim() : '';
        var full = 'Ignition: ' + text;
        if (caption.textContent !== full) caption.textContent = full;
        caption.hidden = text.length <= 28;
      });
    }
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(sync); }
    }
    root.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
